/* eslint-disable no-unused-vars */
/** @jsxRuntime classic */
/** @jsx jsx */
import React from 'react'
import { jsx } from 'theme-ui'

import Box from '/components/Commons/Box'
import Button from '/components/Commons/Button'
import Text from '/components/Commons/Text'
import Image from '/components/Commons/Image'
import ViewStats from '/components/Commons/ViewStats'
import styles from './styles'

const VotePlayer = ({
  statsTitle,
  callForAction,
  onVoteClick,
  voteResponse = false,
  player = {},
  votePlayerId = null,
  idForm,
  ...props
}) => {
  const { name, surname, playerMedia, stats } = player
  const { thumbnail: avatar } = playerMedia
  const mainBox = () => {
    if (votePlayerId && voteResponse) {
      return styles.thanksPlayer
    } else if (votePlayerId) {
      return styles.votedPlayerContainer
    } else {
      return styles.votePlayerContainer
    }
  }

  return (
    <Box sx={mainBox()}>
      <Box sx={styles.playerPhotoContainer}>
        {avatar && (
          <Box
            boxStyle={voteResponse ? styles.playerThanks : styles.playerForm}
          >
            <Image
              {...props}
              width="190px"
              height="190px"
              layout="responsive"
              src={avatar}
              sx={styles.playerImage}
              key={avatar}
            />
          </Box>
        )}
      </Box>
      <Box sx={styles.playerNameAndButtonContainer}>
        <Box sx={styles.playerNameContainer}>
          <Text {...props} textStyle="playerName">
            {name}
          </Text>
          <Text {...props} styles={styles.playerSurname}>
            {surname}
          </Text>
        </Box>
        {!votePlayerId && (
          <>
            <ViewStats responsive={true} surname={surname} stats={stats} />
            <Button
              buttonStyle="voteButton"
              onClick={onVoteClick}
              caption={callForAction.label}
            />
            <ViewStats
              responsive={false}
              surname={surname}
              stats={stats}
              statsTitle={statsTitle}
            />
          </>
        )}
      </Box>
    </Box>
  )
}

export default VotePlayer
